import {
  EnhancedBillingPage,
  PageBillingType,
} from '@mm/state/interfaces/connected-page';
import { EnhancedPlan } from '@mm/state/interfaces/subscription';
import CompanyModel from '@mm/state/model/CompanyModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import {
  defaultProPlanSelector,
  defaultProUnicornPlanSelector,
  defaultTeamPlanSelector,
} from '@mm/state/selectors/subscriptionSelectors';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useActivateSmsRedirectCallback } from '../../../../common/hooks/use-activate-sms-redirect-callback';
import { SettingsRoutes } from '../../../../routes/settings-routes';
import './UpgradeRibbon.pcss';

type Props = {
  facebookPage: EnhancedBillingPage;
  company: CompanyModel;
};

export const UpgradeRibbon = (props: Props) => {
  const { facebookPage } = props;

  const history = useHistory();

  const modalActions = useModalActions();

  const defaultProPlan = useSelector(defaultProPlanSelector);
  const defaultProUnicornPlan = useSelector(defaultProUnicornPlanSelector);
  const defaultTeamPlan = useSelector(defaultTeamPlanSelector);

  const activeCompany = useSelector(activeCompanySelector);
  const isFreePlan = facebookPage.pageBillingType === PageBillingType.Free;
  const isMonthlySubscription =
    facebookPage.subscription?.billingPeriodLength === 'monthly';
  const isOnPROPlan = facebookPage.subscription?.planCode.includes('newpro');
  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  const plan: EnhancedPlan | undefined =
    activeCompany?.persona === 'agency'
      ? defaultTeamPlan
      : november2021Pricing ||
        activeCompany?.persona === 'marketer' ||
        isOnPROPlan
      ? defaultProUnicornPlan
      : defaultProPlan;

  const upgradeText =
    (isFreePlan || isMonthlySubscription) &&
    (activeCompany?.persona === 'agency'
      ? 'UPGRADE TO AGENCY'
      : november2021Pricing ||
        ((isFreePlan || isMonthlySubscription) &&
          activeCompany?.persona === 'marketer') ||
        isOnPROPlan
      ? 'UPGRADE TO STARTUP'
      : 'UPGRADE TO OPERATOR');

  const onSuccessBilling = useActivateSmsRedirectCallback();

  const onClick = () => {
    if (isFreePlan) {
      if (plan) {
        modalActions.openBillingModal({
          facebookPage,
          plan,
          subscription: facebookPage.subscription,
          onSuccessBilling,
          stayOnPage: false,
        });
      } else {
        history.push(SettingsRoutes.billing.getLink());
      }
    } else {
      const upgradeFromSubscriptionId = facebookPage.subscription
        ? facebookPage.subscription.id
        : undefined;

      if (upgradeFromSubscriptionId && plan) {
        modalActions.openBillingModal({
          facebookPage,
          plan,
          upgradeFromSubscriptionId,
          subscription: facebookPage.subscription,
          onSuccessBilling,
        });
      } else {
        history.push(SettingsRoutes.billing.getLink());
      }
    }
  };

  const className = classNames('upgrade-ribbon');

  if (!upgradeText) {
    return null;
  }

  return (
    <div className={className}>
      {upgradeText && (
        <div className="upgrade-ribbon__upgrade-button" onClick={onClick}>
          {upgradeText}
        </div>
      )}
    </div>
  );
};
